import { Measurement } from "./PriceShared.styles";

export function PriceContent({ price = "", styles, unity, canvasScale }) {
  const value = String(price || "");
  if (!value.length) return null;

  return (
    <div className="price-wrapper WRAPPER DO PRICE CONTENT">
      <span className="sign">R$</span>
      <div className="number-wrapper">
        <span className="integer">{value.slice(0, -3)}</span>
        <div className="decimal-unity-wrapper">
          <span className="decimal">{value.slice(-3).replace(".", ",")}</span>
          <Measurement
            fontSize={styles.fontSize}
            color={styles.txtColor}
            canvasScale={canvasScale}
          >
            {unity}
          </Measurement>
        </div>
      </div>
    </div>
  );
}
